var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "flex-column pa-1", attrs: { "no-gutters": "" } },
    [
      !_vm.hideHeader
        ? _c(
            "v-card",
            {
              staticClass: "d-flex align-center justify-space-around",
              staticStyle: { "border-radius": "4px 4px 0px 0px" },
              attrs: { elevation: "2", height: "60px" },
            },
            [
              _vm._t("header", function () {
                return [
                  _vm.$listeners.onButtonBackClick
                    ? _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { left: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.disableBackButton,
                                                  variant: "outlined",
                                                  size: "large",
                                                  icon: "",
                                                  color: "info",
                                                },
                                                on: {
                                                  click:
                                                    _vm.handleBackButtonClick,
                                                },
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-keyboard-backspace"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1573469559
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " + _vm._s(_vm.headerBackTooltip) + " "
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-list-item",
                        { attrs: { "two-line": "" } },
                        [
                          !_vm.isNoWs(_vm.headerImage)
                            ? _c(
                                "v-list-item-avatar",
                                [
                                  _c("v-img", {
                                    attrs: {
                                      src:
                                        _vm.base64ImgPrefix + _vm.headerImage,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "text-truncate" },
                                [_vm._v(" " + _vm._s(_vm.headerTitle))]
                              ),
                              !_vm.isNoWs(_vm.headerSubTitle)
                                ? _c("v-list-item-subtitle", [
                                    _vm._v(" " + _vm._s(_vm.headerSubTitle)),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "v-card",
        {
          staticStyle: { overflow: "auto" },
          attrs: { tile: "", id: "details-area" },
        },
        [_vm._t("details")],
        2
      ),
      !_vm.hideActions
        ? _c(
            "v-card",
            {
              staticClass: "d-flex align-center justify-space-around",
              staticStyle: {
                "border-radius": "0px 0px 4px 4px",
                "z-index": "10",
              },
              attrs: {
                elevation: "2",
                id: "wrapper-actions",
                height: _vm.showTwoActionLines ? "120px" : "60px",
              },
            },
            [_vm._t("actionbuttons")],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }